import http from "../index";

// 省厅详情
export const infoProvince = (params) => {
	return http.post(`/api/v1/province/admin/infoProvince`, params);
};

// 省厅修改密码
export const provinceResetPassword = (params) => {
	return http.post(`/api/v1/province/admin/resetPassword`, params);
};

// 课程列表
export const listCourse = (params) => {
	return http.post(`/api/v1/province/admin/listCourse`, params);
};

// 推荐列表
export const recommendCourseList = (params) => {
	return http.post(`/api/v1/province/admin/recommendCourseList`, params);
};

// 课程详情
export const infoCourse = (params) => {
	return http.post(`/api/v1/province/admin/infoCourse`, params);
};

// 审核课程
export const auditCourse = (params) => {
	return http.post(`/api/v1/province/admin/auditCourse`, params);
};

// 推荐课程
export const recommendCourse = (params) => {
	return http.post(`/api/v1/province/admin/recommendCourse`, params);
};

// 课程列表导出
export const listCourseExport = (params) => {
	return http.post(`/api/v1/province/admin/listCourseExport`, params,{ responseType: 'blob',});
};

// 课程列表导出
export const recommendCourseListExport = (params) => {
	return http.post(`/api/v1/province/admin/recommendCourseListExport`, params, {responseType: 'blob'});
};

// 课程列表导出
export const recommendUpload = (params) => {
	return http.post(`/api/v1/province/admin/recommendUpload`, params, {responseType: 'blob'});
};